import * as angular from 'angular';
import {IController} from "angular";

export class branchDisplayValueCtrl implements IController {
  id: any;

  private selectedBranch: any;

  /* @ngInject */
  constructor(private $branches, private $log) {
  }

  $onInit() {
    this.setItem(this.id);
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.setItem(this.id);
    }
  }

  private setItem(id) {
    if (id) {
      this.$branches(id).$asyncValue()
        .then((branch) => {
          this.selectedBranch = branch;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.selectedBranch = undefined;
    }
  }



}

angular
  .module('bringoz.admin.branches')
  .component('branchDisplayValue', {
    bindings: {
      id: '<',
      onChange: '&'
    },
    template: require('./branch-display-value.html').default,
    controller: branchDisplayValueCtrl
  });
